import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
} from "@angular/forms";
import { DocumentationItem } from "src/app/model/documentation-item";
import { IntegratedAdmissionWizardService } from "../../service/integrated-admission-wizard.service";
import { BehaviorSubject, Subscriber, Subscription } from "rxjs";

@Component({
  selector: "app-integrated-admission-appointment-documentation",
  templateUrl:
    "./integrated-admission-appointment-documentation.component.html",
  styleUrls: ["./integrated-admission-appointment-documentation.component.css"],
})
export class IntegratedAdmissionAppointmentDocumentationComponent
  implements OnInit, OnDestroy
{
  invisible: boolean = true;
  form: FormGroup;
  displayDocumentationItemsColumns = ["name", "carryPatient", "info", "star"];
  documentationItemsDataSource = new BehaviorSubject<AbstractControl[]>([]);
  valorizationSubscription: Subscription;
  readonlySubscription: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    private service: IntegratedAdmissionWizardService
  ) {
    this.form = this.formBuilder.group({
      DocumentationItems: this.formBuilder.array([]),
    });
  }

  ngOnDestroy(): void {
    if (this.valorizationSubscription)
      this.valorizationSubscription.unsubscribe();

    if (this.readonlySubscription) {
      this.readonlySubscription.unsubscribe();
    }
  }

  get documentationItems() {
    return <FormArray>this.form.get("DocumentationItems");
  }

  ngOnInit() {
    this.readonlySubscription = this.service.currentReadOnlySubject$.subscribe(
      (readOnly) => {
        if (readOnly) {
          if (readOnly) {
            this.form.disable();
          }
        }
      }
    );

    this.valorizationSubscription =
      this.service._dataCurrentValorizationSubject.subscribe((data) => {
        if (
          data &&
          data.DocumentationItems &&
          data.DocumentationItems.length > 0
        ) {
          this.addDocumentationItems(data.DocumentationItems);
        } else {
          this.addDocumentationItems([]);
        }
      });
  }

  addDocumentationItems(documentationItems: DocumentationItem[]): void {
    this.form.controls.DocumentationItems = this.formBuilder.array([]);

    documentationItems.forEach((item) => {
      console.log(item.Info);
      const row = this.formBuilder.group({
        RequiredDocumentationId: [item.RequiredDocumentationId],
        DocumentationTypeId: [item.DocumentationTypeId],
        DocumentationItemAgreementId: [item.DocumentationItemAgreementId],
        MedicalAppointmentProcedureId: [item.MedicalAppointmentProcedureId],
        AgreementId: [item.AgreementId],
        Name: [item.Name],
        Description: [item.Description],
        Required: [item.Required],
        MakeWarning: [item.MakeWarning],
        CarryPatient: [item.CarryPatient],
        Info: [item.Info],
        MedicalAppointmentRequiredDocumentationId: [
          item.MedicalAppointmentRequiredDocumentationId,
        ],
      });

      row.controls.CarryPatient.valueChanges.subscribe(() => {
        this.service.setDocuments(
          <DocumentationItem[]>this.documentationItems.getRawValue()
        );
      });

      row.controls.Info.valueChanges.subscribe(() => {
        this.service.setDocuments(
          <DocumentationItem[]>this.documentationItems.getRawValue()
        );
      });

      this.documentationItems.push(row);
    });

    this.documentationItemsDataSource.next(this.documentationItems.controls);
  }

  displayName(index: number): string {
    return (<DocumentationItem>this.documentationItems.controls[index].value)
      .Name;
  }

  displayDescription(index: number): string {
    return (<DocumentationItem>this.documentationItems.controls[index].value)
      .Description;
  }
}
